import { useTranslation } from 'react-i18next';

import s from '../../styles.module.scss';

import type { FC } from 'react';

interface ConsumableBadgeProps {
  consumablesRemainingDays: number;
}

const ConsumableBadge: FC<ConsumableBadgeProps> = ({
  consumablesRemainingDays,
}) => {
  const { t } = useTranslation();

  return (
    <div data-cy="consumables-date-tag" className={s.badge}>
      <p>
        {t('labels.awaitingConsumables')}: {consumablesRemainingDays + 1}{' '}
        {consumablesRemainingDays < 1 ? t('labels.day') : t('labels.days')}
      </p>
    </div>
  );
};
export default ConsumableBadge;
